exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".block-title-color[data-v-4ac77b61]{color:#23252a!important}", ""]);

// exports
